"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RecentSearchClient", {
  enumerable: true,
  get: function get() {
    return _recentSearchClient.default;
  }
});
exports.default = exports._testHook = void 0;

var _recentSearchClient = _interopRequireDefault(require("./recentSearchClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var convertLocalStorageEntriesToFetcherResponse = function convertLocalStorageEntriesToFetcherResponse(localStorageData) {
  if (localStorageData && Array.isArray(localStorageData)) {
    var mappedLocalStorageEntries = localStorageData.map(function (recentSearch) {
      var convertedEntry = {
        category: 'RECENT_SEARCH'
      };

      if (_typeof(recentSearch) === 'object') {
        convertedEntry.displayName = recentSearch.displayName ? recentSearch.displayName : recentSearch.display;
        convertedEntry.subCategory = recentSearch.category;
        convertedEntry.id = recentSearch.subId;
        convertedEntry.coord = recentSearch.coord;
        convertedEntry.topRight = recentSearch.topRight;
        convertedEntry.data = recentSearch.data;
      } else {
        convertedEntry.displayName = recentSearch;
        convertedEntry.subCategory = null;
      }

      return convertedEntry;
    });
    return mappedLocalStorageEntries.reverse(); // we store the most recent entry at the end, but want to place it first in response
  }

  return [];
};

var localStorageExists = function localStorageExists() {
  try {
    var key = 'test';
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

var RecentSearchFetcher = /*#__PURE__*/function () {
  // constructor
  // argument: localStorageKey - the name of the key in local storage where recent searches are stored
  function RecentSearchFetcher(localStorageKey) {
    this.localStorageKey = localStorageKey;
  } // fetchResults
  // returns a Promise that resolves to an array of recent searches


  var _proto = RecentSearchFetcher.prototype;

  _proto.fetchResults = function fetchResults() {
    var recentSearchesData = localStorageExists() ? convertLocalStorageEntriesToFetcherResponse(JSON.parse(localStorage.getItem(this.localStorageKey))) : [];
    return Promise.resolve(recentSearchesData);
  };

  return RecentSearchFetcher;
}();

var _testHook = {
  convertLocalStorageEntriesToFetcherResponse: convertLocalStorageEntriesToFetcherResponse
};
exports._testHook = _testHook;
var _default = RecentSearchFetcher;
exports.default = _default;